import {DateUtils} from '@wallaby-ui/core';
import {FilterUtils} from 'src/js/lib/filtering';
import {FILTER_TYPE_DATE_MONTH_RANGE} from 'src/js/lib/filtering/filters_definitions_constants';

import DateRangeFilter from './date_range_filter';

class MonthRangeFilter extends DateRangeFilter {
  constructor(filterData) {
    super(filterData);
    this.type = filterData.type || FILTER_TYPE_DATE_MONTH_RANGE;
    if (this.value?.startDate === '*') this.value.startDate = null;
    if (this.value?.endDate === '*') this.value.endDate = null;
  }

  static fromString(serializedFilter) {
    if (serializedFilter.endsWith(':*')) {
      return new MonthRangeFilter({
        property: serializedFilter.slice(0, -2),
        value: null,
      });
    }
    const {rangeFrom, rangeTo, property} =
      FilterUtils.getRangeFromString(serializedFilter);
    return new MonthRangeFilter({
      property,
      value: {startDate: rangeFrom, endDate: rangeTo},
    });
  }

  static fromSchema(schemaNode) {
    return new MonthRangeFilter({property: schemaNode.getName()});
  }

  clone() {
    return new MonthRangeFilter({
      type: this.type,
      property: this.property,
      value: {...this.value},
      id: this.id,
    });
  }

  toString() {
    if (this.value != null) {
      return `${this.property}:'${this.value.startDate}' TO '${this.value.endDate}'`;
    }
    return `${this.property}:*`;
  }

  getStartDate() {
    return DateUtils.startOfMonth(DateUtils.fromMonthFormat(this.value.startDate))
  }

  getEndDate() {
    return DateUtils.endOfMonth(DateUtils.fromMonthFormat(this.value.endDate));
  }

  toComponentString(filterSchema, translateService) {
    const node = filterSchema
      ? filterSchema.getFilterByName(this.property)
      : undefined;
    let label = '';
    if (translateService) {
      if (node) {
        label = `${
          translateService.messages[node.getLabel()]
            ? translateService.formatMessage({id: node.getLabel()})
            : node.getLabel()
        }: `;
      }
    } else if (node) {
      label = `${node.getLabel()}: `;
    }
    return `${label}${this.value.startDate} - ${this.value.endDate}`;
  }
}

export default MonthRangeFilter;
